/*
  Fixes: "Cannot read properties of null (reading 'addEventListener')" thrown
  from Shopify.theme.shippingCalculator.init() (assets/theme.js) when it
  instantiates `new Shopify.CountryProvinceSelector('address_country',
  'address_province', ...)` on pages/cart-states where the shipping
  calculator's container/inputs aren't present in the DOM yet. That
  constructor internally calls document.getElementById(id).addEventListener(...)
  with no null check, so it throws whenever those elements are missing -
  this was firing on the large majority of site sessions (confirmed via
  Microsoft Clarity + a live console repro) because init() runs on every
  ajax-cart refresh regardless of whether the shipping calculator markup
  is actually rendered.

  Rather than hand-editing the large bundled assets/theme.js, this wraps
  the existing Shopify.theme.shippingCalculator.init with a guard once
  theme.js has defined it. Loaded immediately after theme.js (see
  layout/theme.liquid) so every existing call site (ajax cart / cart
  drawer refresh) is protected without touching the bundled file.
*/
(function () {
  if (!window.Shopify || !Shopify.theme || !Shopify.theme.shippingCalculator) {
    return;
  }

  var originalInit = Shopify.theme.shippingCalculator.init;

  Shopify.theme.shippingCalculator.init = function () {
    var container = document.querySelector('.shipping-calculator-0');

    if (
      !container ||
      !document.getElementById('address_country') ||
      !document.getElementById('address_province')
    ) {
      return false;
    }

    return originalInit.apply(this, arguments);
  };
})();
